/**
 * Grupo abierto en la barra lateral clásica tras pulsar `id`.
 * Pulsar el grupo abierto lo cierra; restaurar el grupo anotado (`soloAbrir`)
 * lo deja abierto aunque la carga ya lo haya abierto por default.
 */
export function grupoAbiertoTrasPulsar(
  actual: number | null,
  id: number,
  soloAbrir = false,
): number | null {
  if (soloAbrir) return id;
  return actual === id ? null : id;
}

/**
 * El grupo tiene en pantalla una de sus etapas. No depende de que esté
 * desplegado: plegarlo no cambia lo que muestra la grilla.
 */
export function flujoEnPantalla(
  grupo: { items?: Array<{ id: number | string }> } | null | undefined,
  etapaActiva: number | null,
): boolean {
  if (etapaActiva == null || etapaActiva <= 0) return false;
  return (grupo?.items ?? []).some((item) => Number(item.id) === etapaActiva);
}
